import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';

export default function Navbar() {
  return (
    <Box sx={{ flexGrow: 1, m: 0 }}>
      <AppBar position="static">
        <Toolbar>
          <Stack
            direction="row"
            sx={{ width: 1, textDecoration: 'none', color: 'inherit' }}
            component={Link}
            to="/"
          >
            <img src="img/logo.svg" width={32} height={32} alt="Logo" />
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, ml: 2 }}
            >
              QR Barcode Tools
            </Typography>
          </Stack>

          <MenuItem component={Link} to="/about ">
            About
          </MenuItem>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
